import { RootStateOrAny } from 'react-redux';

export const selectDefaultThemeColour = (state: RootStateOrAny): string =>
  state.core.get('defaultThemeColour');

export const selectCookiesDisabledAcknowledgement = (
  state: RootStateOrAny,
): boolean => state.core.get('cookiesDisabledAcknowledgement');
